import axios from 'axios';
import { ACCOUNT_BASE_API_URL } from '../config/config';

export const api = axios.create({
    baseURL: ACCOUNT_BASE_API_URL,
    headers: { 'Content-Type': 'application/json' },
});


api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('auth_token') 
               || sessionStorage.getItem('token') 
               || sessionStorage.getItem('userToken');

 
    
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers['X-Auth-Token'] = token; 
    }

    return config;
});